@file:OptIn(InternalResourceApi::class)

package fr.frux.feature.map.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/fr.frux.feature.map.resources/"

@delegate:ResourceContentHash(988_170_373)
internal val Res.string.map_action_list_description: StringResource by lazy {
      StringResource("string:map_action_list_description", "map_action_list_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 120, 75),
      ))
    }

@delegate:ResourceContentHash(1_938_610_195)
internal val Res.string.map_action_locate_me_description: StringResource by lazy {
      StringResource("string:map_action_locate_me_description", "map_action_locate_me_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 196, 56),
      ))
    }

@delegate:ResourceContentHash(-1_995_774_068)
internal val Res.string.map_action_locating_description: StringResource by lazy {
      StringResource("string:map_action_locating_description", "map_action_locating_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 253, 67),
      ))
    }

@delegate:ResourceContentHash(761_543_622)
internal val Res.string.map_aim_current_position_description: StringResource by lazy {
      StringResource("string:map_aim_current_position_description", "map_aim_current_position_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 321, 84),
      ))
    }

@delegate:ResourceContentHash(-563_180_309)
internal val Res.string.map_aim_distance: StringResource by lazy {
      StringResource("string:map_aim_distance", "map_aim_distance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 406, 32),
      ))
    }

@delegate:ResourceContentHash(-1_332_359_473)
internal val Res.string.map_aim_pin_description: StringResource by lazy {
      StringResource("string:map_aim_pin_description", "map_aim_pin_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 439, 79),
      ))
    }

@delegate:ResourceContentHash(-1_031_005_767)
internal val Res.string.map_aim_pin_outside_description: StringResource by lazy {
      StringResource("string:map_aim_pin_outside_description", "map_aim_pin_outside_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 519, 83),
      ))
    }

@delegate:ResourceContentHash(998_140_203)
internal val Res.string.map_aim_zoom_in: StringResource by lazy {
      StringResource("string:map_aim_zoom_in", "map_aim_zoom_in", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 603, 31),
      ))
    }

@delegate:ResourceContentHash(1_780_093_657)
internal val Res.string.map_aim_zoom_out: StringResource by lazy {
      StringResource("string:map_aim_zoom_out", "map_aim_zoom_out", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 635, 36),
      ))
    }

@delegate:ResourceContentHash(1_654_157_661)
internal val Res.string.map_attribution_collectivites: StringResource by lazy {
      StringResource("string:map_attribution_collectivites", "map_attribution_collectivites", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 672, 73),
      ))
    }

@delegate:ResourceContentHash(1_849_391_395)
internal val Res.string.map_attribution_osm: StringResource by lazy {
      StringResource("string:map_attribution_osm", "map_attribution_osm", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 746, 75),
      ))
    }

@delegate:ResourceContentHash(-750_166_926)
internal val Res.string.map_confirmation_view: StringResource by lazy {
      StringResource("string:map_confirmation_view", "map_confirmation_view", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 822, 37),
      ))
    }

@delegate:ResourceContentHash(-1_067_554_694)
internal val Res.string.map_empty_add_known: StringResource by lazy {
      StringResource("string:map_empty_add_known", "map_empty_add_known", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 860, 71),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.map_empty_dismiss: StringResource by lazy {
      StringResource("string:map_empty_dismiss", "map_empty_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 932, 33),
      ))
    }

@delegate:ResourceContentHash(-1_056_130_915)
internal val Res.string.map_empty_nearest: StringResource by lazy {
      StringResource("string:map_empty_nearest", "map_empty_nearest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 966, 65),
      ))
    }

@delegate:ResourceContentHash(1_145_652_522)
internal val Res.string.map_empty_seasonal_heading: StringResource by lazy {
      StringResource("string:map_empty_seasonal_heading", "map_empty_seasonal_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1032, 66),
      ))
    }

@delegate:ResourceContentHash(384_125_029)
internal val Res.string.map_empty_show_nearest: StringResource by lazy {
      StringResource("string:map_empty_show_nearest", "map_empty_show_nearest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1099, 74),
      ))
    }

@delegate:ResourceContentHash(741_689_744)
internal val Res.string.map_empty_subtitle: StringResource by lazy {
      StringResource("string:map_empty_subtitle", "map_empty_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1174, 194),
      ))
    }

@delegate:ResourceContentHash(1_960_647_088)
internal val Res.string.map_empty_title: StringResource by lazy {
      StringResource("string:map_empty_title", "map_empty_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1458, 71),
      ))
    }

@delegate:ResourceContentHash(1_815_848_725)
internal val Res.string.map_empty_title_near: StringResource by lazy {
      StringResource("string:map_empty_title_near", "map_empty_title_near", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1369, 88),
      ))
    }

@delegate:ResourceContentHash(-1_165_511_322)
internal val Res.string.map_empty_what_can_i_add: StringResource by lazy {
      StringResource("string:map_empty_what_can_i_add", "map_empty_what_can_i_add", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1530, 64),
      ))
    }

@delegate:ResourceContentHash(1_221_620_709)
internal val Res.string.map_filtered_empty_anywhere: StringResource by lazy {
      StringResource("string:map_filtered_empty_anywhere", "map_filtered_empty_anywhere", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1595, 91),
      ))
    }

@delegate:ResourceContentHash(7_095_522)
internal val Res.string.map_filtered_empty_generic: StringResource by lazy {
      StringResource("string:map_filtered_empty_generic", "map_filtered_empty_generic", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1687, 98),
      ))
    }

@delegate:ResourceContentHash(1_276_678_210)
internal val Res.string.map_filtered_empty_season: StringResource by lazy {
      StringResource("string:map_filtered_empty_season", "map_filtered_empty_season", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1786, 73),
      ))
    }

@delegate:ResourceContentHash(-2_075_160_118)
internal val Res.string.map_filtered_empty_show_nearest: StringResource by lazy {
      StringResource("string:map_filtered_empty_show_nearest", "map_filtered_empty_show_nearest", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1860, 67),
      ))
    }

@delegate:ResourceContentHash(-2_091_504_691)
internal val Res.string.map_filtered_empty_species: StringResource by lazy {
      StringResource("string:map_filtered_empty_species", "map_filtered_empty_species", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1928, 82),
      ))
    }

@delegate:ResourceContentHash(2_132_668_396)
internal val Res.string.map_filters_button_description: StringResource by lazy {
      StringResource("string:map_filters_button_description", "map_filters_button_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2089, 50),
      ))
    }

@delegate:ResourceContentHash(-1_729_525_354)
internal val Res.string.map_filters_button_description_active: StringResource by lazy {
      StringResource("string:map_filters_button_description_active", "map_filters_button_description_active", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2011, 77),
      ))
    }

@delegate:ResourceContentHash(2_011_221_653)
internal val Res.string.map_filters_chip_harvest_part_feuille: StringResource by lazy {
      StringResource("string:map_filters_chip_harvest_part_feuille", "map_filters_chip_harvest_part_feuille", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2140, 57),
      ))
    }

@delegate:ResourceContentHash(-1_626_482_701)
internal val Res.string.map_filters_chip_harvest_part_fleur: StringResource by lazy {
      StringResource("string:map_filters_chip_harvest_part_fleur", "map_filters_chip_harvest_part_fleur", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2198, 51),
      ))
    }

@delegate:ResourceContentHash(-2_110_496_830)
internal val Res.string.map_filters_chip_harvest_part_fruit: StringResource by lazy {
      StringResource("string:map_filters_chip_harvest_part_fruit", "map_filters_chip_harvest_part_fruit", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2250, 51),
      ))
    }

@delegate:ResourceContentHash(241_480_015)
internal val Res.string.map_filters_chip_harvest_part_noix: StringResource by lazy {
      StringResource("string:map_filters_chip_harvest_part_noix", "map_filters_chip_harvest_part_noix", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2302, 62),
      ))
    }

@delegate:ResourceContentHash(-622_291_043)
internal val Res.string.map_filters_chip_harvest_part_racine: StringResource by lazy {
      StringResource("string:map_filters_chip_harvest_part_racine", "map_filters_chip_harvest_part_racine", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2365, 56),
      ))
    }

@delegate:ResourceContentHash(-1_273_697_826)
internal val Res.string.map_filters_chip_hide_needs_check: StringResource by lazy {
      StringResource("string:map_filters_chip_hide_needs_check", "map_filters_chip_hide_needs_check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2422, 85),
      ))
    }

@delegate:ResourceContentHash(-2_062_091_957)
internal val Res.string.map_filters_chip_in_season: StringResource by lazy {
      StringResource("string:map_filters_chip_in_season", "map_filters_chip_in_season", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2508, 46),
      ))
    }

@delegate:ResourceContentHash(-1_851_754_604)
internal val Res.string.map_filters_chip_plant_form_arbre: StringResource by lazy {
      StringResource("string:map_filters_chip_plant_form_arbre", "map_filters_chip_plant_form_arbre", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2555, 49),
      ))
    }

@delegate:ResourceContentHash(1_445_038_890)
internal val Res.string.map_filters_chip_plant_form_arbuste: StringResource by lazy {
      StringResource("string:map_filters_chip_plant_form_arbuste", "map_filters_chip_plant_form_arbuste", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2605, 55),
      ))
    }

@delegate:ResourceContentHash(499_852_482)
internal val Res.string.map_filters_chip_plant_form_herbacee: StringResource by lazy {
      StringResource("string:map_filters_chip_plant_form_herbacee", "map_filters_chip_plant_form_herbacee", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2661, 60),
      ))
    }

@delegate:ResourceContentHash(2_146_453_534)
internal val Res.string.map_filters_chip_plant_form_liane: StringResource by lazy {
      StringResource("string:map_filters_chip_plant_form_liane", "map_filters_chip_plant_form_liane", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2722, 49),
      ))
    }

@delegate:ResourceContentHash(-804_883_185)
internal val Res.string.map_filters_clear_all: StringResource by lazy {
      StringResource("string:map_filters_clear_all", "map_filters_clear_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2772, 45),
      ))
    }

@delegate:ResourceContentHash(-549_693_645)
internal val Res.string.map_filters_section_harvest_part: StringResource by lazy {
      StringResource("string:map_filters_section_harvest_part", "map_filters_section_harvest_part", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2818, 64),
      ))
    }

@delegate:ResourceContentHash(286_766_415)
internal val Res.string.map_filters_section_identification: StringResource by lazy {
      StringResource("string:map_filters_section_identification", "map_filters_section_identification", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2883, 62),
      ))
    }

@delegate:ResourceContentHash(389_115_842)
internal val Res.string.map_filters_section_plant_form: StringResource by lazy {
      StringResource("string:map_filters_section_plant_form", "map_filters_section_plant_form", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2946, 62),
      ))
    }

@delegate:ResourceContentHash(1_351_008_370)
internal val Res.string.map_filters_section_season: StringResource by lazy {
      StringResource("string:map_filters_section_season", "map_filters_section_season", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3087, 42),
      ))
    }

@delegate:ResourceContentHash(831_114_072)
internal val Res.string.map_filters_section_season_highlights: StringResource by lazy {
      StringResource("string:map_filters_section_season_highlights", "map_filters_section_season_highlights", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3009, 77),
      ))
    }

@delegate:ResourceContentHash(1_383_584_463)
internal val Res.string.map_filters_sheet_description: StringResource by lazy {
      StringResource("string:map_filters_sheet_description", "map_filters_sheet_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3130, 65),
      ))
    }

@delegate:ResourceContentHash(2_132_668_396)
internal val Res.string.map_filters_title: StringResource by lazy {
      StringResource("string:map_filters_title", "map_filters_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3196, 37),
      ))
    }

@delegate:ResourceContentHash(511_823_637)
internal val Res.string.map_first_contribution_add_another: StringResource by lazy {
      StringResource("string:map_first_contribution_add_another", "map_first_contribution_add_another", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3234, 74),
      ))
    }

@delegate:ResourceContentHash(2_059_970_191)
internal val Res.string.map_first_contribution_body: StringResource by lazy {
      StringResource("string:map_first_contribution_body", "map_first_contribution_body", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3309, 235),
      ))
    }

@delegate:ResourceContentHash(-2_122_258_561)
internal val Res.string.map_first_contribution_first_here: StringResource by lazy {
      StringResource("string:map_first_contribution_first_here", "map_first_contribution_first_here", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3545, 125),
      ))
    }

@delegate:ResourceContentHash(425_422_311)
internal val Res.string.map_first_contribution_photo_failed: StringResource by lazy {
      StringResource("string:map_first_contribution_photo_failed", "map_first_contribution_photo_failed", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3671, 127),
      ))
    }

@delegate:ResourceContentHash(-804_671_236)
internal val Res.string.map_first_contribution_see_on_map: StringResource by lazy {
      StringResource("string:map_first_contribution_see_on_map", "map_first_contribution_see_on_map", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3799, 65),
      ))
    }

@delegate:ResourceContentHash(485_483_308)
internal val Res.string.map_first_contribution_title: StringResource by lazy {
      StringResource("string:map_first_contribution_title", "map_first_contribution_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3865, 84),
      ))
    }

@delegate:ResourceContentHash(-972_834_044)
internal val Res.string.map_group_close_description: StringResource by lazy {
      StringResource("string:map_group_close_description", "map_group_close_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3950, 55),
      ))
    }

@delegate:ResourceContentHash(1_895_338_563)
internal val Res.string.map_group_subtitle: StringResource by lazy {
      StringResource("string:map_group_subtitle", "map_group_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4006, 78),
      ))
    }

@delegate:ResourceContentHash(-1_089_149_702)
internal val Res.string.map_group_title: StringResource by lazy {
      StringResource("string:map_group_title", "map_group_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4085, 47),
      ))
    }

@delegate:ResourceContentHash(1_765_373_071)
internal val Res.string.map_legend_cluster: StringResource by lazy {
      StringResource("string:map_legend_cluster", "map_legend_cluster", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4133, 298),
      ))
    }

@delegate:ResourceContentHash(-1_074_341_395)
internal val Res.string.map_legend_content_description: StringResource by lazy {
      StringResource("string:map_legend_content_description", "map_legend_content_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4432, 66),
      ))
    }

@delegate:ResourceContentHash(1_939_141_995)
internal val Res.string.map_legend_families_heading: StringResource by lazy {
      StringResource("string:map_legend_families_heading", "map_legend_families_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4499, 59),
      ))
    }

@delegate:ResourceContentHash(738_092_867)
internal val Res.string.map_legend_family_autre: StringResource by lazy {
      StringResource("string:map_legend_family_autre", "map_legend_family_autre", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4559, 51),
      ))
    }

@delegate:ResourceContentHash(-320_360_819)
internal val Res.string.map_legend_family_coque: StringResource by lazy {
      StringResource("string:map_legend_family_coque", "map_legend_family_coque", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4611, 55),
      ))
    }

@delegate:ResourceContentHash(-1_011_298_359)
internal val Res.string.map_legend_family_dore: StringResource by lazy {
      StringResource("string:map_legend_family_dore", "map_legend_family_dore", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4667, 50),
      ))
    }

@delegate:ResourceContentHash(-1_326_711_945)
internal val Res.string.map_legend_family_pomme_poire: StringResource by lazy {
      StringResource("string:map_legend_family_pomme_poire", "map_legend_family_pomme_poire", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4718, 57),
      ))
    }

@delegate:ResourceContentHash(171_445_277)
internal val Res.string.map_legend_family_prune_baies: StringResource by lazy {
      StringResource("string:map_legend_family_prune_baies", "map_legend_family_prune_baies", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4776, 57),
      ))
    }

@delegate:ResourceContentHash(2_023_887_452)
internal val Res.string.map_legend_family_rouge: StringResource by lazy {
      StringResource("string:map_legend_family_rouge", "map_legend_family_rouge", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4834, 51),
      ))
    }

@delegate:ResourceContentHash(496_374_296)
internal val Res.string.map_legend_grey_statuses: StringResource by lazy {
      StringResource("string:map_legend_grey_statuses", "map_legend_grey_statuses", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4886, 48),
      ))
    }

@delegate:ResourceContentHash(-999_194_767)
internal val Res.string.map_legend_intensity_heading: StringResource by lazy {
      StringResource("string:map_legend_intensity_heading", "map_legend_intensity_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4935, 76),
      ))
    }

@delegate:ResourceContentHash(908_853_446)
internal val Res.string.map_legend_notched_description: StringResource by lazy {
      StringResource("string:map_legend_notched_description", "map_legend_notched_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5012, 182),
      ))
    }

@delegate:ResourceContentHash(-1_531_680_358)
internal val Res.string.map_legend_shapes_heading: StringResource by lazy {
      StringResource("string:map_legend_shapes_heading", "map_legend_shapes_heading", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5195, 61),
      ))
    }

@delegate:ResourceContentHash(822_773_251)
internal val Res.string.map_legend_subtitle: StringResource by lazy {
      StringResource("string:map_legend_subtitle", "map_legend_subtitle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5257, 151),
      ))
    }

@delegate:ResourceContentHash(139_842_504)
internal val Res.string.map_legend_title: StringResource by lazy {
      StringResource("string:map_legend_title", "map_legend_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5409, 44),
      ))
    }

@delegate:ResourceContentHash(696_429_096)
internal val Res.string.map_legend_tree_marker: StringResource by lazy {
      StringResource("string:map_legend_tree_marker", "map_legend_tree_marker", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5454, 90),
      ))
    }

@delegate:ResourceContentHash(1_109_635_864)
internal val Res.string.map_loading_trees: StringResource by lazy {
      StringResource("string:map_loading_trees", "map_loading_trees", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5545, 57),
      ))
    }

@delegate:ResourceContentHash(1_308_835_594)
internal val Res.string.map_location_notice_action_allow: StringResource by lazy {
      StringResource("string:map_location_notice_action_allow", "map_location_notice_action_allow", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5603, 52),
      ))
    }

@delegate:ResourceContentHash(1_578_946_115)
internal val Res.string.map_location_notice_action_settings: StringResource by lazy {
      StringResource("string:map_location_notice_action_settings", "map_location_notice_action_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5656, 55),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.map_location_notice_dismiss: StringResource by lazy {
      StringResource("string:map_location_notice_dismiss", "map_location_notice_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5712, 43),
      ))
    }

@delegate:ResourceContentHash(-941_085_626)
internal val Res.string.map_location_notice_permanently_denied_settings: StringResource by lazy {
      StringResource("string:map_location_notice_permanently_denied_settings", "map_location_notice_permanently_denied_settings", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5756, 163),
      ))
    }

@delegate:ResourceContentHash(-546_587_656)
internal val Res.string.map_location_notice_permanently_denied_web: StringResource by lazy {
      StringResource("string:map_location_notice_permanently_denied_web", "map_location_notice_permanently_denied_web", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5920, 162),
      ))
    }

@delegate:ResourceContentHash(696_272_016)
internal val Res.string.map_location_notice_permission_denied_default: StringResource by lazy {
      StringResource("string:map_location_notice_permission_denied_default", "map_location_notice_permission_denied_default", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6083, 125),
      ))
    }

@delegate:ResourceContentHash(558_737_188)
internal val Res.string.map_location_notice_permission_denied_explain: StringResource by lazy {
      StringResource("string:map_location_notice_permission_denied_explain", "map_location_notice_permission_denied_explain", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6209, 145),
      ))
    }

@delegate:ResourceContentHash(1_029_978_872)
internal val Res.string.map_location_notice_unavailable: StringResource by lazy {
      StringResource("string:map_location_notice_unavailable", "map_location_notice_unavailable", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6355, 123),
      ))
    }

@delegate:ResourceContentHash(867_353_065)
internal val Res.string.map_login_prompt_action: StringResource by lazy {
      StringResource("string:map_login_prompt_action", "map_login_prompt_action", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6479, 47),
      ))
    }

@delegate:ResourceContentHash(-1_884_758_011)
internal val Res.string.map_login_prompt_message: StringResource by lazy {
      StringResource("string:map_login_prompt_message", "map_login_prompt_message", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6527, 80),
      ))
    }

@delegate:ResourceContentHash(12_011_863)
internal val Res.string.map_marker_callout_needs_check: StringResource by lazy {
      StringResource("string:map_marker_callout_needs_check", "map_marker_callout_needs_check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6608, 54),
      ))
    }

@delegate:ResourceContentHash(-1_132_430_611)
internal val Res.string.map_marker_callout_with_distance: StringResource by lazy {
      StringResource("string:map_marker_callout_with_distance", "map_marker_callout_with_distance", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6663, 60),
      ))
    }

@delegate:ResourceContentHash(141_043_503)
internal val Res.string.map_marker_label_needs_check: StringResource by lazy {
      StringResource("string:map_marker_label_needs_check", "map_marker_label_needs_check", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6724, 60),
      ))
    }

@delegate:ResourceContentHash(1_739_180_776)
internal val Res.string.map_nearby_empty: StringResource by lazy {
      StringResource("string:map_nearby_empty", "map_nearby_empty", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6785, 76),
      ))
    }

@delegate:ResourceContentHash(-1_890_801_171)
internal val Res.string.map_nearby_see_all: StringResource by lazy {
      StringResource("string:map_nearby_see_all", "map_nearby_see_all", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6862, 38),
      ))
    }

@delegate:ResourceContentHash(1_588_180_896)
internal val Res.string.map_nearby_title: StringResource by lazy {
      StringResource("string:map_nearby_title", "map_nearby_title", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6951, 44),
      ))
    }

@delegate:ResourceContentHash(-1_708_359_758)
internal val Res.string.map_nearby_title_area: StringResource by lazy {
      StringResource("string:map_nearby_title_area", "map_nearby_title_area", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6901, 49),
      ))
    }

@delegate:ResourceContentHash(1_916_864_806)
internal val Res.string.map_never_seen_invite: StringResource by lazy {
      StringResource("string:map_never_seen_invite", "map_never_seen_invite", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7062, 97),
      ))
    }

@delegate:ResourceContentHash(-2_037_320_067)
internal val Res.string.map_never_seen_invite_dismiss: StringResource by lazy {
      StringResource("string:map_never_seen_invite_dismiss", "map_never_seen_invite_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6996, 65),
      ))
    }

@delegate:ResourceContentHash(1_707_039_062)
internal val Res.string.map_populated_hint_dismiss: StringResource by lazy {
      StringResource("string:map_populated_hint_dismiss", "map_populated_hint_dismiss", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7160, 42),
      ))
    }

@delegate:ResourceContentHash(1_126_972_796)
internal val Res.string.map_populated_hint_text: StringResource by lazy {
      StringResource("string:map_populated_hint_text", "map_populated_hint_text", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7203, 135),
      ))
    }

@delegate:ResourceContentHash(-1_511_595_850)
internal val Res.string.map_search_area_idle: StringResource by lazy {
      StringResource("string:map_search_area_idle", "map_search_area_idle", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7339, 64),
      ))
    }

@delegate:ResourceContentHash(1_327_656_375)
internal val Res.string.map_search_area_searching: StringResource by lazy {
      StringResource("string:map_search_area_searching", "map_search_area_searching", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7404, 49),
      ))
    }

@delegate:ResourceContentHash(1_229_918_150)
internal val Res.string.map_search_clear_description: StringResource by lazy {
      StringResource("string:map_search_clear_description", "map_search_clear_description", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7454, 64),
      ))
    }

@delegate:ResourceContentHash(-1_733_176_359)
internal val Res.string.map_search_placeholder: StringResource by lazy {
      StringResource("string:map_search_placeholder", "map_search_placeholder", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7519, 82),
      ))
    }

@delegate:ResourceContentHash(-2_144_779_811)
internal val Res.string.map_search_places_header: StringResource by lazy {
      StringResource("string:map_search_places_header", "map_search_places_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7602, 40),
      ))
    }

@delegate:ResourceContentHash(694_734_942)
internal val Res.string.map_search_species_header: StringResource by lazy {
      StringResource("string:map_search_species_header", "map_search_species_header", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 7643, 45),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("map_action_list_description", Res.string.map_action_list_description)
  map.put("map_action_locate_me_description", Res.string.map_action_locate_me_description)
  map.put("map_action_locating_description", Res.string.map_action_locating_description)
  map.put("map_aim_current_position_description", Res.string.map_aim_current_position_description)
  map.put("map_aim_distance", Res.string.map_aim_distance)
  map.put("map_aim_pin_description", Res.string.map_aim_pin_description)
  map.put("map_aim_pin_outside_description", Res.string.map_aim_pin_outside_description)
  map.put("map_aim_zoom_in", Res.string.map_aim_zoom_in)
  map.put("map_aim_zoom_out", Res.string.map_aim_zoom_out)
  map.put("map_attribution_collectivites", Res.string.map_attribution_collectivites)
  map.put("map_attribution_osm", Res.string.map_attribution_osm)
  map.put("map_confirmation_view", Res.string.map_confirmation_view)
  map.put("map_empty_add_known", Res.string.map_empty_add_known)
  map.put("map_empty_dismiss", Res.string.map_empty_dismiss)
  map.put("map_empty_nearest", Res.string.map_empty_nearest)
  map.put("map_empty_seasonal_heading", Res.string.map_empty_seasonal_heading)
  map.put("map_empty_show_nearest", Res.string.map_empty_show_nearest)
  map.put("map_empty_subtitle", Res.string.map_empty_subtitle)
  map.put("map_empty_title", Res.string.map_empty_title)
  map.put("map_empty_title_near", Res.string.map_empty_title_near)
  map.put("map_empty_what_can_i_add", Res.string.map_empty_what_can_i_add)
  map.put("map_filtered_empty_anywhere", Res.string.map_filtered_empty_anywhere)
  map.put("map_filtered_empty_generic", Res.string.map_filtered_empty_generic)
  map.put("map_filtered_empty_season", Res.string.map_filtered_empty_season)
  map.put("map_filtered_empty_show_nearest", Res.string.map_filtered_empty_show_nearest)
  map.put("map_filtered_empty_species", Res.string.map_filtered_empty_species)
  map.put("map_filters_button_description", Res.string.map_filters_button_description)
  map.put("map_filters_button_description_active", Res.string.map_filters_button_description_active)
  map.put("map_filters_chip_harvest_part_feuille", Res.string.map_filters_chip_harvest_part_feuille)
  map.put("map_filters_chip_harvest_part_fleur", Res.string.map_filters_chip_harvest_part_fleur)
  map.put("map_filters_chip_harvest_part_fruit", Res.string.map_filters_chip_harvest_part_fruit)
  map.put("map_filters_chip_harvest_part_noix", Res.string.map_filters_chip_harvest_part_noix)
  map.put("map_filters_chip_harvest_part_racine", Res.string.map_filters_chip_harvest_part_racine)
  map.put("map_filters_chip_hide_needs_check", Res.string.map_filters_chip_hide_needs_check)
  map.put("map_filters_chip_in_season", Res.string.map_filters_chip_in_season)
  map.put("map_filters_chip_plant_form_arbre", Res.string.map_filters_chip_plant_form_arbre)
  map.put("map_filters_chip_plant_form_arbuste", Res.string.map_filters_chip_plant_form_arbuste)
  map.put("map_filters_chip_plant_form_herbacee", Res.string.map_filters_chip_plant_form_herbacee)
  map.put("map_filters_chip_plant_form_liane", Res.string.map_filters_chip_plant_form_liane)
  map.put("map_filters_clear_all", Res.string.map_filters_clear_all)
  map.put("map_filters_section_harvest_part", Res.string.map_filters_section_harvest_part)
  map.put("map_filters_section_identification", Res.string.map_filters_section_identification)
  map.put("map_filters_section_plant_form", Res.string.map_filters_section_plant_form)
  map.put("map_filters_section_season", Res.string.map_filters_section_season)
  map.put("map_filters_section_season_highlights", Res.string.map_filters_section_season_highlights)
  map.put("map_filters_sheet_description", Res.string.map_filters_sheet_description)
  map.put("map_filters_title", Res.string.map_filters_title)
  map.put("map_first_contribution_add_another", Res.string.map_first_contribution_add_another)
  map.put("map_first_contribution_body", Res.string.map_first_contribution_body)
  map.put("map_first_contribution_first_here", Res.string.map_first_contribution_first_here)
  map.put("map_first_contribution_photo_failed", Res.string.map_first_contribution_photo_failed)
  map.put("map_first_contribution_see_on_map", Res.string.map_first_contribution_see_on_map)
  map.put("map_first_contribution_title", Res.string.map_first_contribution_title)
  map.put("map_group_close_description", Res.string.map_group_close_description)
  map.put("map_group_subtitle", Res.string.map_group_subtitle)
  map.put("map_group_title", Res.string.map_group_title)
  map.put("map_legend_cluster", Res.string.map_legend_cluster)
  map.put("map_legend_content_description", Res.string.map_legend_content_description)
  map.put("map_legend_families_heading", Res.string.map_legend_families_heading)
  map.put("map_legend_family_autre", Res.string.map_legend_family_autre)
  map.put("map_legend_family_coque", Res.string.map_legend_family_coque)
  map.put("map_legend_family_dore", Res.string.map_legend_family_dore)
  map.put("map_legend_family_pomme_poire", Res.string.map_legend_family_pomme_poire)
  map.put("map_legend_family_prune_baies", Res.string.map_legend_family_prune_baies)
  map.put("map_legend_family_rouge", Res.string.map_legend_family_rouge)
  map.put("map_legend_grey_statuses", Res.string.map_legend_grey_statuses)
  map.put("map_legend_intensity_heading", Res.string.map_legend_intensity_heading)
  map.put("map_legend_notched_description", Res.string.map_legend_notched_description)
  map.put("map_legend_shapes_heading", Res.string.map_legend_shapes_heading)
  map.put("map_legend_subtitle", Res.string.map_legend_subtitle)
  map.put("map_legend_title", Res.string.map_legend_title)
  map.put("map_legend_tree_marker", Res.string.map_legend_tree_marker)
  map.put("map_loading_trees", Res.string.map_loading_trees)
  map.put("map_location_notice_action_allow", Res.string.map_location_notice_action_allow)
  map.put("map_location_notice_action_settings", Res.string.map_location_notice_action_settings)
  map.put("map_location_notice_dismiss", Res.string.map_location_notice_dismiss)
  map.put("map_location_notice_permanently_denied_settings", Res.string.map_location_notice_permanently_denied_settings)
  map.put("map_location_notice_permanently_denied_web", Res.string.map_location_notice_permanently_denied_web)
  map.put("map_location_notice_permission_denied_default", Res.string.map_location_notice_permission_denied_default)
  map.put("map_location_notice_permission_denied_explain", Res.string.map_location_notice_permission_denied_explain)
  map.put("map_location_notice_unavailable", Res.string.map_location_notice_unavailable)
  map.put("map_login_prompt_action", Res.string.map_login_prompt_action)
  map.put("map_login_prompt_message", Res.string.map_login_prompt_message)
  map.put("map_marker_callout_needs_check", Res.string.map_marker_callout_needs_check)
  map.put("map_marker_callout_with_distance", Res.string.map_marker_callout_with_distance)
  map.put("map_marker_label_needs_check", Res.string.map_marker_label_needs_check)
  map.put("map_nearby_empty", Res.string.map_nearby_empty)
  map.put("map_nearby_see_all", Res.string.map_nearby_see_all)
  map.put("map_nearby_title", Res.string.map_nearby_title)
  map.put("map_nearby_title_area", Res.string.map_nearby_title_area)
  map.put("map_never_seen_invite", Res.string.map_never_seen_invite)
  map.put("map_never_seen_invite_dismiss", Res.string.map_never_seen_invite_dismiss)
  map.put("map_populated_hint_dismiss", Res.string.map_populated_hint_dismiss)
  map.put("map_populated_hint_text", Res.string.map_populated_hint_text)
  map.put("map_search_area_idle", Res.string.map_search_area_idle)
  map.put("map_search_area_searching", Res.string.map_search_area_searching)
  map.put("map_search_clear_description", Res.string.map_search_clear_description)
  map.put("map_search_placeholder", Res.string.map_search_placeholder)
  map.put("map_search_places_header", Res.string.map_search_places_header)
  map.put("map_search_species_header", Res.string.map_search_species_header)
}
